import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { BaseCategoryTypeEnum, IApiRequest, IApiresponse } from 'src/app/_models';
import { IManageCategoryListRequest } from 'src/app/_models/manage-category/manage-category-list-request';
import { IManageCategoryListResponse, ManageCategoryListResponse } from 'src/app/_models/manage-category/manage-category-list-response';
import { IDefaultParams, DefaultParams } from 'src/app/_models/common/request-response/default-params';
import { IDeviceInfo, DeviceInfo } from 'src/app/_models/common/request-response/device-info';
import { IManageCategoryAddUpdateResponse } from 'src/app/_models/manage-category/manage-category-add-update-response';
import { Claims } from 'src/app/_models/common/claims';
import { ClaimsService } from 'src/app/_services/common/claims.service';
import { ITaxRateMasterResponse } from 'src/app/_models/manage-category/tax-rate-master-response';
import { IManageCategoryBulkUpdateRequest } from 'src/app/_models/manage-category/manage-category-bulk-update-request';
import { IManageCategoryBulkUpdateResponse } from 'src/app/_models/manage-category/manage-category-bulk-update-response';
import { ClaimsHeaderService } from '../../shared/claimsHeader/claims-header.service';
import { IManageCategoryResponse } from 'src/app/_models/manage-category/manage-category-response';
import { IRequestGetTaxRateListForAssignCategory } from 'src/app/_models/manage-category/request-get-tax-rate-list-for-assign-category';
import { ITaxRateMappedCategoryList } from 'src/app/_models/manage-category/tax-rate-mapped-category-list';
import { ICartDetailsRequest, ICartDetailsResponse } from 'src/app/_models/organisation-setting/organisation-setting';
import { OrgExpenseCategoryResponse } from 'src/app/_models/manage-category/orgExpenseCategoryResponse';
import { OrgExpenseCategoryRequest } from 'src/app/_models/manage-category/orgExpenseCategoryRequest';
import { map } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { OrgEntertainmentCategoryView } from 'src/app/_models/manage-category/org-entertainment-category-view';
import { ManageCategoryCommonEnum } from 'src/app/_models/manage-category/manage-category-enum';
import { ICategoryListForTaxAssignmentResponse,ITaxRateListForTaxAssignmentResponse,IUpdateTaxRateToEntertainmentCategoryRequest,IBulkImportExpenseCategoryResponse,IBulkImportExpenseCategoryRequest, BulkImportCategory, BulkCategorySaveRequest, SpecialCatExportSaveRequest }
 from "src/app/_models/manage-category/expense-category";

@Injectable({
  providedIn: 'root'
})
export class ManageCategoryService {

  employeeListUrl: any;
  employeeCounterUrl: any;
  approverListUrl: any;
  ownershipTypeList: any; 
  loginIDHistoryUrl: any;
  defaultParams: IDefaultParams;
  deviceInfo: IDeviceInfo;

  orgId: number;
  userId: number;
  organisationCurrency: string;
  claims: Claims;
  constructor(private http: HttpClient, private claimsService: ClaimsService, private claimsHeaderService: ClaimsHeaderService
    , private translate: TranslateService) {
    this.claimsService.currentClaims.subscribe(claims => this.claims = claims);
    this.orgId = this.claims.OrgId;
    this.userId = this.claims.UserId;
    this.organisationCurrency = this.claims.CurrentOrganisationCurrency;
    this.defaultParams = new DefaultParams(this.orgId, this.userId, this.claims.FinanceManager, environment.requestTimeStamp);
    this.deviceInfo = new DeviceInfo(this.organisationCurrency, environment.platform,
      environment.applicationVersion.toString(), environment.appId, environment.deviceId, this.detectBrowserName(), this.detectBrowserVersion());
    this.defaultParams.deviceInfo = this.deviceInfo;

  }

  detectBrowserName() { 
    const agent = window.navigator.userAgent.toLowerCase()
    switch (true) {
      case agent.indexOf('firefox') > -1:
        return 'firefox';
      case agent.indexOf('opr') > -1 && !!(<any>window).opr:
          return 'opera';     
      case agent.indexOf('trident') > -1:
          return 'ie';
      case agent.indexOf('edg') > -1:
          return 'edge';
      case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
        return 'chrome';   
      case agent.indexOf('safari') > -1:
        return 'safari';
      default:
        return 'other';
    }
  }
   
  detectBrowserVersion(){
      let userAgent = navigator.userAgent, tem, 
      matchTest = userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
      
      if(/trident/i.test(matchTest[1])){
          tem =  /\brv[ :]+(\d+)/g.exec(userAgent) || [];
          return 'IE '+(tem[1] || '');
      }
      if(matchTest[1]=== 'Chrome'){
          tem = userAgent.match(/\b(OPR|Edge)\/(\d+)/);
          if(tem!= null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
      }
      matchTest= matchTest[2]? [matchTest[1], matchTest[2]]: [navigator.appName, navigator.appVersion, '-?'];
      if((tem= userAgent.match(/version\/(\d+)/i))!= null) matchTest.splice(1, 1, tem[1]);
      return matchTest.join(' ');
  }

  SoloAddUpdateOrgCategory(requestinfo: IApiRequest<IManageCategoryListResponse>): Observable<IApiresponse<IManageCategoryAddUpdateResponse>> {
    let body = JSON.stringify(requestinfo);
    return this.http.post<IApiresponse<IManageCategoryAddUpdateResponse>>(`${environment.billingApiUrl}AddUpdateOrgCategory`, body, { headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
  }

  SoloAddUpdateVendorOrgCategory(requestinfo: IApiRequest<IManageCategoryListResponse>): Observable<IApiresponse<IManageCategoryAddUpdateResponse>> {
    let body = JSON.stringify(requestinfo);
    return this.http.post<IApiresponse<IManageCategoryAddUpdateResponse>>(`${environment.apAutomationUrl}AddUpdateOrgCategory`, body, { headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
  }

  SoloBulkUpdateOrgCategory(requestinfo: IApiRequest<IManageCategoryBulkUpdateRequest>): Observable<IApiresponse<IManageCategoryBulkUpdateResponse>> {
    let body = JSON.stringify(requestinfo);
    return this.http.post<IApiresponse<IManageCategoryBulkUpdateResponse>>(`${environment.billingApiUrl}BulkUpdateOrgCategory`, body, { headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
  }


  GetActiveOrgManageCatListByOrgId(requestinfo: OrgExpenseCategoryRequest): Observable<IApiresponse<IManageCategoryListResponse[]>> {
    let body = JSON.stringify(requestinfo);
    return this.http.post<IApiresponse<IManageCategoryListResponse[]>>(`${environment.billingApiUrl}GetActiveOrgManageCatListByOrgId`, body, { headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
  }

  SoloGetOrgCategoriesByBaseCategoryId(baseCategoryId): Observable<IApiresponse<IManageCategoryListResponse[]>> {
    let params = new HttpParams();
    params = params.append("baseCategoryId", baseCategoryId);
    let url = `${environment.billingApiUrl}GetOrgCategoriesByBaseCategoryId`;
    return this.http.get<IApiresponse<IManageCategoryListResponse[]>>(url,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader(), params: params });
  }

  ValidateSpecialCategoryMapping(requestinfo: IApiRequest<any>): Observable<IApiresponse<any>> {
    let body = JSON.stringify(requestinfo);
    return this.http.post<IApiresponse<any>>(`${environment.expenseApiUrl}ValidateSpecialCategoryMapping`, body, { headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
  }

  SoloGetOrgCategoryByOrgCategoryId(orgExpenseCategoryId): Observable<IApiresponse<IManageCategoryListResponse>> {
    let params = new HttpParams();
    params = params.append("orgExpenseCategoryId", orgExpenseCategoryId);
    let url = `${environment.billingApiUrl}GetOrgCategoryByOrgCategoryId`;
    return this.http.get<IApiresponse<IManageCategoryListResponse>>(url,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader(), params: params });
  }

  SoloGetBaseCategoryList() {
    return this.GenarateBaseCategoryList();
  }
  GenarateBaseCategoryList() {
    let baseCategoryResponse = [
      {
        baseCategoryId: 1,
        baseCategoryName: this.translate.instant("baseCategory_mileage"),
        status: 1
      },
      {
        baseCategoryId: 2,
        baseCategoryName: this.translate.instant("baseCategory_mileage_gps"),
        status: 1
      },
      {
        baseCategoryId: 3,
        baseCategoryName: this.translate.instant("baseCategory_mileage_google"),
        status: 1
      },
      {
        baseCategoryId: 4,
        baseCategoryName: this.translate.instant("baseCategory_hotel"),
        status: 1
      },
      {
        baseCategoryId: 5,
        baseCategoryName: this.translate.instant("baseCategory_entertainment"),
        status: 1
      },
      {
        baseCategoryId: 6,
        baseCategoryName: this.translate.instant("baseCategory_standard"),
        status: 1
      }
      ,
      {
        baseCategoryId: 9,
        baseCategoryName: this.translate.instant("receipt_type_text9"),
        status: 1
      }
    ]
    return baseCategoryResponse;
  }
  SoloGetAllTaxRates(): Observable<IApiresponse<ITaxRateMasterResponse[]>> {
    let url = `${environment.billingApiUrl}GetAllTaxRatesForExpenseCategory`;
    return this.http.get<IApiresponse<ITaxRateMasterResponse[]>>(url, { headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
  }

  SoloGetTaxRateForAssignCategoryByOrgId(requestinfo: IApiRequest<IRequestGetTaxRateListForAssignCategory>): Observable<IApiresponse<any>> {
    let body = JSON.stringify(requestinfo);
    return this.http.post<IApiresponse<any>>(`${environment.billingApiUrl}GetTaxRateForAssignCategoryByOrgId`, body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
  }

  SoloAssignDeassignTaxRateToCategory(requestinfo: IApiRequest<ITaxRateMappedCategoryList>): Observable<IApiresponse<any>> {
    let body = JSON.stringify(requestinfo);
    return this.http.post<IApiresponse<any>>(`${environment.billingApiUrl}AssignDeassignTaxRateToCategory`, body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
  }

  SoloCheckFunctionPurchased(functionId: string): Observable<IApiresponse<boolean>> {
    let params = new HttpParams();
    params = params.append("functionId", functionId);
    let url = `${environment.billingApiUrl}CheckFunctionPurchased`;
    return this.http.get<IApiresponse<boolean>>(url, { params: params, headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
  }

  SaveCartDetails(requestinfo: IApiRequest<ICartDetailsRequest>): Observable<IApiresponse<ICartDetailsResponse>> {
    requestinfo.requestInfo.UserId = this.userId;
    requestinfo.requestInfo.OrganisationId = this.orgId;
    let body = JSON.stringify(requestinfo);
    return this.http.post<IApiresponse<ICartDetailsResponse>>(`${environment.catalogApiUrl}SaveCartDetails`, body, { headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
  }
  SoloGetOrganisationGooglePackage() {
    let params = new HttpParams();
    params = params.append("organisationId", this.orgId.toString());

    return this.http.get<any>(
      `${environment.billingApiUrl}GetOrganisationGooglePackage`,
      { params: params, headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

  SoloGetOrgManageCatListByOrgIdStatus(requestinfo: IApiRequest<OrgExpenseCategoryRequest>): Observable<IApiresponse<OrgExpenseCategoryResponse[]>> {
    let body = JSON.stringify(requestinfo);
    return this.http.post<IApiresponse<OrgExpenseCategoryResponse[]>>(`${environment.billingApiUrl}GetOrgManageCatListByOrgIdStatus`, body, { headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
  }

  SaveExpCatForUniversalImport(requestinfo: IApiRequest<ManageCategoryListResponse[]>): Observable<IApiresponse<IManageCategoryAddUpdateResponse>> {
    let body = JSON.stringify(requestinfo);
    return this.http.post<IApiresponse<IManageCategoryAddUpdateResponse>>(`${environment.billingApiUrl}SaveExpCatForUniversalImport`, body, { headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
  }
  //ManageCategoryListResponse
  SoloGetOrgManageCatList(requestinfo: IApiRequest<IManageCategoryListRequest>): Observable<any> {
    let body = JSON.stringify(requestinfo);
    return this.http.post<IApiresponse<IManageCategoryResponse>>
      (`${environment.billingApiUrl}GetOrgManageCatList`, body,
        { headers: this.claimsHeaderService.createLoginAuthorizationHeader() })
      .pipe(map(result => this.mapCatList(result.responseInfo)));
  }

  SoloGetOrgVendorManageCatList(requestinfo: IApiRequest<IManageCategoryListRequest>): Observable<any> {
    let body = JSON.stringify(requestinfo);
    return this.http.post<IApiresponse<IManageCategoryResponse>>
      (`${environment.apAutomationUrl}GetOrgManageCatList`, body,
        { headers: this.claimsHeaderService.createLoginAuthorizationHeader() })
      .pipe(map(result => this.mapCatList(result.responseInfo)));
  }
  GetCategoriesAndItemsData(requestinfo: IApiRequest<IManageCategoryListRequest>): Observable<any> {
    let body = JSON.stringify(requestinfo);
    return this.http.post<IApiresponse<IManageCategoryResponse>>
      (`${environment.apAutomationUrl}GetCategoriesAndItemsData`, body,
        { headers: this.claimsHeaderService.createLoginAuthorizationHeader() })
      .pipe(map(result => this.mapCatList(result.responseInfo)));
  }

  taxRateMasterResponse: any;
  mapCatList(result: IManageCategoryResponse): any {
    this.taxRateMasterResponse = result.taxRateMasterResponse;
    let response: any = null;
    if (result) {
      response = {
        taxRateMasterResponse: result.taxRateMasterResponse,
        totalCount: result.manageCategoryListResponse? result.manageCategoryListResponse.length:0,
        activeCount: result.manageCategoryListResponse? result.manageCategoryListResponse.filter(a => a.isActive == true).length:0,
        inActiveCount: result.manageCategoryListResponse? result.manageCategoryListResponse.filter(a => a.isActive == false).length:0,
        manageCategoryList: result.manageCategoryListResponse? result.manageCategoryListResponse.map(e => this.mapCat(e)):[]
      };
    }
    return response;
  }

  mapCat(e: ManageCategoryListResponse): any {
    return {
      orgExpenseCategoryId: e.orgExpenseCategoryId,
      expenseCategoryName: e.expenseCategoryName,
      isActive: e.isActive,
      baseCategoryId: e.baseCategoryId,
      baseCategoryName: e.baseCategoryName,
      updatedOn: e.updatedOn,
      orgEntertainmentCategoryView: e.orgEntertainmentCategoryView,
      accountingSystemParameter: e.accountingSystemParameter,
      status: e.isActive == true ? "1" : "0",
      isPurchaseMessageRequired: e.isPurchaseMessageRequired,
      isCategoryDisabled: e.isCategoryDisabled,
      expenseCategoryId: e.expenseCategoryId,
      isMultiDateAllowed: e.isMultiDateAllowed,
      isPaid: e.isPaid,
      isPayActual: e.isPayActual,
      icon: e.icon,
      isTipsEnabled: e.isTipsEnabled,
      organisationId: e.organisationId,
      createdBy: e.createdBy,
      accountingCode: e.accountingCode,
      guestAccountingCode: this.fnSetEntTaxRateIdInGrid(e.orgEntertainmentCategoryView, ManageCategoryCommonEnum.AccountingCode, 'guestAccountingCode'),
      tipsAccountingCode: this.fnSetEntTaxRateIdInGrid(e.orgEntertainmentCategoryView, ManageCategoryCommonEnum.AccountingCode, 'tipsAccountingCode'),
      guestTaxRateMasterId: this.fnSetEntTaxRateIdInGrid(e.orgEntertainmentCategoryView, ManageCategoryCommonEnum.TaxRate, 'guestTaxRateMasterId'),
      tipsTaxRateMasterId: this.fnSetEntTaxRateIdInGrid(e.orgEntertainmentCategoryView, ManageCategoryCommonEnum.TaxRate, 'tipsTaxRateMasterId'),
      taxRateId: e.baseCategoryId == BaseCategoryTypeEnum.Entertainment
        ? this.fnSetEntTaxRateIdInGrid(e.orgEntertainmentCategoryView, ManageCategoryCommonEnum.TaxRate, 'taxRateId')
        : e.taxRateId,
      accountingCodeApplied: e.baseCategoryId == BaseCategoryTypeEnum.Entertainment
        ? this.fnSetEntRowInGrid(e.orgEntertainmentCategoryView, ManageCategoryCommonEnum.AccountingCode)
        : e.accountingCode,
      taxApplied: e.baseCategoryId == BaseCategoryTypeEnum.Entertainment
        ? this.fnSetEntRowInGrid(e.orgEntertainmentCategoryView, ManageCategoryCommonEnum.TaxRate)
        : this.fnMapTaxRatesToTaxRateId(e.taxRateId),
      customFields: e.customFields,
      isNotesMandatory: e.isNotesMandatory,
      isCustomRate: e.isCustomRate,
      mileageRate: e.mileageRate,
      isTriangulationEnabled: e.isTriangulationEnabled,
      type: e.type,
      settingType: e.settingType,
      orgSubCategoryMappings: e.orgSubCategoryMappings,
      customFieldsCount: e.customFields ? e.customFields.length : 0,
      categoryItems: e.categoryItems,
      categoryItemsCount: e.categoryItems ? e.categoryItems.length : 0,
      isPerkSynced: e.isPerkSynced,
    };
  }
  returnVal: any;
  fnSetEntTaxRateIdInGrid(item: OrgEntertainmentCategoryView, type, columnName) {
    if (type == ManageCategoryCommonEnum.TaxRate) {
      if (!item)
        return 0;
      switch (columnName) {
        case 'guestTaxRateMasterId':
          this.returnVal = item.guestTaxId;
          break;
        case 'tipsTaxRateMasterId':
          this.returnVal = item.tipsTaxId;
          break;
        case 'taxRateId':
          this.returnVal = item.clientTaxId;
          break;
      }
    }
    else {
      if (!item)
        return "";
      switch (columnName) {
        case 'guestAccountingCode':
          this.returnVal = item.guestAccountingCode;
          break;
        case 'tipsAccountingCode':
          this.returnVal = item.tipsAccountingCode;
          break;
      }
    }
    return this.returnVal;
  }
  fnSetEntRowInGrid(item: OrgEntertainmentCategoryView, columnName) {
    if (!item)
      return '';
    let rowText = "";
    item.clientAccountingCode =
      item.clientAccountingCode != "" && item.clientAccountingCode != null
        ? item.clientAccountingCode
        : null;
    item.guestAccountingCode =
      item.guestAccountingCode != "" && item.guestAccountingCode != null
        ? item.guestAccountingCode
        : null;
    item.tipsAccountingCode =
      item.tipsAccountingCode != "" && item.tipsAccountingCode != null
        ? item.tipsAccountingCode
        : null;
    if (columnName == ManageCategoryCommonEnum.AccountingCode) {
      const codes = [
        { code: item.clientAccountingCode, label: "manageCat_emp" },
        { code: item.guestAccountingCode, label: "manageCat_guests" },
        { code: item.tipsAccountingCode, label: "manageCat_tips" }
      ];
    
      rowText = codes
        .filter(c => c.code != null)
        .map(c => `${c.code} ${this.translate.instant(c.label)}`)
        .join(" | ");
    } else {
      item.clientTax =
        item.clientTaxId != null && item.clientTaxId != 0
          ? this.fnMapTaxRatesToTaxRateId(item.clientTaxId)
          : null;
      item.guestTax =
        item.guestTaxId != null && item.guestTaxId != 0
          ? this.fnMapTaxRatesToTaxRateId(item.guestTaxId)
          : null;
      item.tipsTax =
        item.tipsTaxId != null && item.tipsTaxId != 0
          ? this.fnMapTaxRatesToTaxRateId(item.tipsTaxId)
          : null;
      const taxRates = [
        {rate: item.clientTax, label: this.translate.instant("manageCat_emp")},
        {rate: item.guestTax, label: this.translate.instant("manageCat_guests")},
        {rate: item.tipsTax, label: this.translate.instant("manageCat_tips")},
      ];
      rowText = taxRates.filter(a => a.rate != null)
      .map(c => `${c.rate} ${c.label}`)
      .join(" | ");
    }
    return rowText;
  }

  fnMapTaxRatesToTaxRateId(taxRateId: number) {
    if (this.taxRateMasterResponse != null) {
      let taxRateDetail = this.taxRateMasterResponse.filter(function (it) {
        return it.taxRateMasterId == taxRateId;
      });
      if (taxRateDetail.length > 0) {
        return taxRateDetail[0].taxCode + ' - ' + taxRateDetail[0].taxRate + '%';
      } else {
        return "";
      }
    }
  }


  GetCategoryListForTaxAssignment(organisationId: number): Observable<IApiresponse<ICategoryListForTaxAssignmentResponse[]>> {
    let params = new HttpParams();
    params = params.append("organisationId", organisationId.toString());
    return this.http.get<IApiresponse<ICategoryListForTaxAssignmentResponse[]>>(
        `${environment.billingApiUrl}GetCategoryListForTaxAssignment`,
        {
            params: params,
            headers: this.claimsHeaderService.createLoginAuthorizationHeader()
        }
    );
}

GetTaxRateListForTaxAssignment(organisationId: number): Observable<IApiresponse<ITaxRateListForTaxAssignmentResponse[]>> {
  let params = new HttpParams();
  params = params.append("organisationId", organisationId.toString());
  return this.http.get<IApiresponse<ITaxRateListForTaxAssignmentResponse[]>>(
      `${environment.billingApiUrl}GetTaxRateListForTaxAssignment`,
      {
          params: params,
          headers: this.claimsHeaderService.createLoginAuthorizationHeader()
      }
  );
}

UpdateTaxRateToEntertainmentCategory(requestinfo: IApiRequest<IUpdateTaxRateToEntertainmentCategoryRequest>): Observable<IApiresponse<any>> {
  let body = JSON.stringify(requestinfo);
  return this.http.post<IApiresponse<any>>(`${environment.billingApiUrl}UpdateTaxRateToEntertainmentCategory`, body,
    { headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
}


GetCategoryImportSampleData() {
  return this.http.get('/assets/sample-data/import/import-category.json');
}

ValidateBulkImportExpenseCategory(
  requestInfo: IApiRequest<IBulkImportExpenseCategoryRequest>): Observable<IApiresponse<IBulkImportExpenseCategoryResponse>> {
  let body = JSON.stringify(requestInfo);
  return this.http.post<IApiresponse<IBulkImportExpenseCategoryResponse>>(
    `${environment.billingApiUrl}ValidateBulkImportExpenseCategory`,
    body,
    { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
  );
}

BulkAddUpdateOrgCategory(requestinfo: IApiRequest<BulkCategorySaveRequest>): Observable<IApiresponse<IManageCategoryAddUpdateResponse>> {
  let body = JSON.stringify(requestinfo);
  return this.http.post<IApiresponse<IManageCategoryAddUpdateResponse>>(`${environment.billingApiUrl}BulkAddUpdateOrgCategory`, body, { headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
}

SpecialCategoryExportSetup(requestinfo: IApiRequest<SpecialCatExportSaveRequest>): Observable<IApiresponse<IManageCategoryAddUpdateResponse>> {
  let body = JSON.stringify(requestinfo);
  return this.http.post<IApiresponse<IManageCategoryAddUpdateResponse>>(`${environment.billingApiUrl}SpecialCategoryExportSetup`, body, { headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
}


}

